import { ciLaptop } from '~/icons/source/light/laptop'
import { ciSmartphone } from '~/icons/source/light/smartphone'
import { ciChip } from '~/icons/source/regular/chip'
import { ciShieldCheck } from '~/icons/source/light/shield-check'
import { ciCashier } from '~/icons/source/light/cashier'
import { ciStroller } from '~/icons/source/light/stroller'
import { ciJobSearch } from '~/icons/source/light/job-search'
import { ciFashion } from '~/icons/source/light/fashion'
import { ciDiamond } from '~/icons/source/light/diamond'
import { ciProduct } from '~/icons/source/light/product'
import { ciAshtray } from '~/icons/source/light/ashtray'
import { ciShampoo } from '~/icons/source/light/shampoo'
import { ciRunning } from '~/icons/source/light/running'
import { ciBook } from '~/icons/source/light/book'
import { ciTent } from '~/icons/source/light/tent'
import { ciFishingRod } from '~/icons/source/light/fishing-rod'
import { ciHorseback } from '~/icons/source/light/horseback'
import { ciMusicNote } from '~/icons/source/regular/music-note'
import { ciDeer } from '~/icons/source/light/deer'
import { ciWeightlifting } from '~/icons/source/light/weightlifting'
import { ciPlugin } from '~/icons/source/regular/plugin'
import { ciHome } from '~/icons/source/solid/home'
import { ciTrack } from '~/icons/source/light/track'
import { ciBuffet } from '~/icons/source/regular/buffet'
import { ciGasStove } from '~/icons/source/light/gas-stove'
import { ciToolbox } from '~/icons/source/light/toolbox'
import { ciUnisex } from '~/icons/source/light/unisex'
import { ciGramophone } from '~/icons/source/light/gramophone'
import { ciWatch } from '~/icons/source/light/watch'

export const categoryKeyFeaturesIcons = Object.freeze({
  // tech and self defense
  laptops: {
    icon: ciLaptop
  },
  mobiles: {
    icon: ciSmartphone
  },
  'mobile_phones_&_accessories': {
    icon: ciSmartphone
  },
  technology_security: {
    icon: ciChip
  },
  security_systems_self_defence: {
    icon: ciShieldCheck
  },
  security_systems: {
    icon: ciShieldCheck
  },
  // business_equipment
  business_equipment: {
    icon: ciCashier
  },
  // children_goods
  children_goods: {
    icon: ciStroller
  },
  // employment_services
  employment_services: {
    icon: ciJobSearch
  },
  // fashion
  fashion: {
    icon: ciFashion
  },
  jewellery: {
    icon: ciDiamond
  },
  // food_drinks_supermarket_products
  food_drinks_supermarket_products: {
    icon: ciProduct
  },
  smoking_accessories: {
    icon: ciAshtray
  },
  // health beauty
  health_medical_cosmetics: {
    icon: ciShampoo
  },
  // hobby
  sports_items: {
    icon: ciRunning
  },
  'accessories_&_sports_miscellaneous': {
    icon: ciRunning
  },
  books: {
    icon: ciBook
  },
  camping_supplies: {
    icon: ciTent
  },
  sea_fishing_scuba_diving: {
    icon: ciFishingRod
  },
  riding: {
    icon: ciHorseback
  },
  'musical_instruments_&_accessories': {
    icon: ciMusicNote
  },
  hunting_shooting_archery: {
    icon: ciDeer
  },
  gym_organs: {
    icon: ciWeightlifting
  },
  toys_free_time: {
    icon: ciPlugin
  },
  // house_garden_pets_animals
  house_garden_pets_animals: {
    icon: ciHome
  },
  'dogs_&_accessories': {
    icon: ciTrack
  },
  // mass_catering_equipment
  mass_catering_equipment: {
    icon: ciBuffet
  },
  catering: {
    icon: ciBuffet
  },
  ovens: {
    icon: ciGasStove
  },
  // tools_&_accessories
  'tools_&_accessories': {
    icon: ciToolbox
  },
  unisex_miscellaneous: {
    icon: ciUnisex
  },
  clothes_linen: {
    icon: ciFashion
  },
  antiques: {
    icon: ciGramophone
  },
  // level 2
  watches: {
    icon: ciWatch
  },
  // level 3
  computers: {
    icon: ciLaptop
  },
  // default
  classifieds: {
    icon: ciHome,
    classes: 'icon--blue'
  }
})
